import { isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Password, TwoStepVerification } from '.';
import { SubCategoryLink } from '../components';
import { isActiveFor } from '../shared';
import * as S from '../shared.styles';

export class SecurityAndSafety extends React.PureComponent {
    public render(): React.ReactElement {
        return (
            <S.SubCategoryRow>
                {isTabletPortraitDown() && this.renderMobile()}
                {!isTabletPortraitDown() && this.renderLeftColumn()}
                {!isTabletPortraitDown() && this.renderRightColumn()}
            </S.SubCategoryRow>
        );
    }

    private readonly renderMobile = (): React.ReactElement => (
        <Switch>
            <Route path="/settings/security-and-safety" exact={true} render={this.renderLeftColumn} />
            <Route path="/settings/security-and-safety/password" exact={true} component={Password} />
            <Route
                path="/settings/security-and-safety/two-step-verification"
                exact={true}
                component={TwoStepVerification}
            />
        </Switch>
    );

    private readonly renderLeftColumn = (): React.ReactElement => (
        <S.SubCategoryCol>
            <S.SubCategoryHeader>
                {isTabletPortraitDown() && (
                    <S.ReturnLink to="/settings">
                        {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                    </S.ReturnLink>
                )}
                <S.SubCategoryH1>Security & Safety</S.SubCategoryH1>
            </S.SubCategoryHeader>
            <SubCategoryLink
                first={true}
                to="/settings/security-and-safety/password"
                label="Password"
                isActive={isActiveFor('/settings/security-and-safety')}
            />
            <SubCategoryLink to="/settings/security-and-safety/two-step-verification" label="Two-Step Verification" />
        </S.SubCategoryCol>
    );
    private readonly renderRightColumn = (): React.ReactElement => (
        <S.SubCategoryCol>
            <Switch>
                <Route path="/settings/security-and-safety/password" component={Password} />
                <Route path="/settings/security-and-safety/two-step-verification" component={TwoStepVerification} />
                <Route path="/settings/security-and-safety" exact={true} component={Password} />
            </Switch>
        </S.SubCategoryCol>
    );
}
